var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui main container"},[_c('Catalog',{attrs:{"store":"orders","header":"Mis pedidos","addButtonLabel":"","columns":_vm.columns,"editOn":"/orders","addOn":"","hideAdd":true,"hideDelete":true,"defaultRecordsPerPage":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }